export default __webpack_public_path__ + "static/media/success-alert.d2f32f1f.mp3";